import { type LinearConfiguratorState } from "~/features/configurator/Linear/redux/types";
import { type LinearConfiguration } from "~/features/configurator/Linear/models";
import { sendLinear } from "~/features/configurator/Linear/api/sendLinearCommon";
import { buildConfiguratorNavigationCommand } from "~/features/configurator/common/api/configuratorCommands";

export function sendLinearStepChange(linearState: LinearConfiguratorState): Promise<LinearConfiguration> {
  return sendLinear(buildConfiguratorNavigationCommand(linearState));
}
